import { BrandLogoGroup, EditableValue, LabelValue } from '@retail/components';
import { SelectInputField } from '@shared/components';
import React from 'react';
import { useCampaignTFunction } from '@retail/campaign/i18n';
import { Brand } from '@retail/auth/types';

interface Props {
  brands: Brand[];
  availableBrands: Brand[];
  onSave?: (brandIds: string[]) => void;
}

export const CampaignBrands = ({ brands, availableBrands, onSave }: Props) => {
  const t = useCampaignTFunction();

  return (
    <LabelValue
      label={t('campaign.columns.brands')}
      value={
        <EditableValue
          editable={!!onSave && availableBrands.length > 1}
          onSave={(brandIds) => onSave && onSave(brandIds)}
          defaultValue={brands.map((b) => b.brandId)}
          renderValue={() => <BrandLogoGroup brands={brands} max={4} />}
          validate={(brandIds) => {
            if (!brandIds?.length) {
              return t('campaign.error.atLeastOneBrand');
            }
            return undefined;
          }}
          renderInput={({ value, onChange, error }) => (
            <SelectInputField
              menuItems={availableBrands.map((brand) => ({
                name: brand.name,
                value: brand.brandId,
              }))}
              value={value}
              onChange={(e) => {
                onChange(e.target.value as string[]);
              }}
              multiple
              menuItemHasSpaceBetween={false}
              error={error}
              size="small"
              margin="none"
            />
          )}
        />
      }
      orientation="vertical"
      spacing={0.5}
    />
  );
};
